// 初始化 state
import { getSTS } from "@/api/file";
import OSS from "ali-oss";

const file = {
  namespaced: true,
  state: {
    ossClient: null,
    ossClientTime: 0
  },
  getters: {
    ossClient: state => state.ossClient,
    ossClientTime: state => state.ossClientTime
  },
  actions: {
    async initOssClient({ commit }) {
      let res = await getSTS();
      await commit("OSS_CLIENT", res);
      return Promise.resolve(res);
    }
  },
  mutations: {
    ["OSS_CLIENT"](state, res) {
      if (res && res.code === 200) {
        state.ossClientTime = new Date().getTime();
        state.ossClient = new OSS.Wrapper({
          region: "oss-cn-beijing",
          accessKeyId: res.data.accessKeyId,
          accessKeySecret: res.data.accessKeySecret,
          stsToken: res.data.securityToken,
          bucket: "oss-zczk"
        });
      }
    }
  }
};

export default file;
